import Grid from '@mui/material/Grid';
import { observer } from 'mobx-react-lite';
import { Button, HintBox, RichTextField } from '../../../components';
import { useStore } from '../../../store';
import { AccountServicesHelp } from '../../../store/constants/help';
import { onSuccess } from '../../../utils/errors';
import Configurations from '../store/Configurations';

export default observer(function OrderEmailTemplate({
  configurations,
}: {
  configurations: Configurations;
}) {
  const { accountStore } = useStore();
  const provider = configurations.webhooks.selectedProvider;

  if (!configurations.isWebhookEnabled || !provider) {
    return null;
  }

  async function onSendTestClick() {
    await accountStore.testEmailTemplate(configurations.orderEmailTemplate);
    onSuccess(`Test email sent to ${accountStore.account?.email}`);
  }

  return (
    <Grid container spacing={6}>
      <Grid item xs={8}>
        <RichTextField
          label="Pulse Email Template"
          name="orderEmailTemplate"
          onChange={configurations.handleChangeAndSave}
          value={configurations.orderEmailTemplate}
        />
        <Button
          icon="paper-plane"
          onClick={onSendTestClick}
          size="small"
          sx={{ mt: 1 }}
          type="secondary"
        >
          Send test email
        </Button>
      </Grid>
      <Grid item xs={4}>
        <HintBox help={AccountServicesHelp.emailTemplate} />
      </Grid>
    </Grid>
  );
});
